export const adapt12hoursTimeTo24hoursTime = (time12hours: string): string => {
  const timeParts = time12hours.match(/(\d{1,2}):(\d{2})\s?(AM|PM)/i);

  if (!timeParts) {
    return '';
  }

  let hours = parseInt(timeParts[1], 10);
  const minutes = timeParts[2];
  const period = timeParts[3].toUpperCase();

  if (period === 'PM' && hours < 12) {
    hours += 12;
  } else if (period === 'AM' && hours === 12) {
    hours = 0;
  }

  const hoursStr = hours.toString().padStart(2, '0');

  return `${hoursStr}:${minutes}`;
}